<script lang="ts">
	import { DataHandlerFolderAdmin, DataHandlerMediaAdmin } from "luxedo-data"
	import { FileSystemMedia } from "../../../modules/FileSystems"


	interface Props {
		path: Array<{ id: number; name: string }>;
		root: {
		id: number
		name: string
	};
		updateActiveDirectory: (folderID: number) => void;
	}

	let { path, root, updateActiveDirectory }: Props = $props();

	/**
	 * Handles when a dragged object is dropped onto a path element
	 * @param e DragEvent object (contains dataTransfer data)
	 * @param id ID of the folder being dropped onto
	 */
	function handleDrop(e: DragEvent, id: number) {
		e.preventDefault()
		// @ts-ignore
		e.target.classList.remove("hover")

		const dropType = e.dataTransfer.getData("type")
		const entryID = Number(e.dataTransfer.getData("file"))
		let dropFile
		if (dropType === "folder") {
			dropFile = DataHandlerFolderAdmin.get(entryID)
		} else {
			dropFile = DataHandlerMediaAdmin.get(entryID)
		}
		const dropToFolder = DataHandlerFolderAdmin.get(id)
		FileSystemMedia.move(dropFile, dropToFolder)
	}

	/**
	 * Called when an object is being dragged over a path element
	 */
	function initDropHover(e: DragEvent) {
		e.preventDefault()
		// @ts-ignore
		e.target.classList.add("hover")
	}

	/**
	 * Called when drag is canceled or finished
	 * @param e
	 */
	function clearDropHover(e: DragEvent) {
		// @ts-ignore
		e.target.classList.remove("hover")
	}
</script>

<span class="current-path">
	<a
		ondragend={clearDropHover}
		ondragleave={clearDropHover}
		ondragover={initDropHover}
		ondrop={(e) => handleDrop(e, root.id)}
		href="#/"
		onkeypress={(e) => {
			e.preventDefault()
			if (e.key === "Enter") updateActiveDirectory(root.id)
		}}
		onclick={(e) => {
			e.preventDefault()
			updateActiveDirectory(root.id)
		}}
		>{root.name}
	</a>
	{#each path as { id, name }}
		<span>/</span>
		<a
			ondragend={clearDropHover}
			ondragleave={clearDropHover}
			ondragover={initDropHover}
			ondrop={(e) => handleDrop(e, id)}
			href="#/"
			onkeypress={(e) => {
				e.preventDefault()
				if (e.key === "Enter") updateActiveDirectory(id)
			}}
			onclick={(e) => {
				e.preventDefault()
				updateActiveDirectory(id)
			}}>{name}</a
		>
	{/each}
</span>

<style>
	.current-path {
		display: flex;
		flex-direction: row;
		align-items: flex-start;
		width: 100%;
		overflow-x: scroll;
		overflow-y: hidden;
		height: 3rem;
		line-height: unset;
		background-color: var(--color-bg-light);
		border-radius: var(--br);
		padding: 0 1rem;
		box-shadow: var(--shadow-medium);
	}

	.current-path > a {
		height: 1.5rem;
		white-space: nowrap;
		display: inline-block;
		cursor: pointer;
		border-color: transparent;
		transition: border-color var(--transition-duration);
		padding: 0 0.25rem;
	}

	.current-path > a:global(.hover),
	.current-path > a:hover,
	.current-path > a:focus-visible {
		border-color: var(--color-accent);
	}

	.current-path > a:last-of-type {
		cursor: default;
		text-decoration: none;
		border-color: transparent;
		color: var(--color-text);
	}
</style>
